<template>
	<div class="card">
		<div class="card-body" v-if="jsonCurso.length >= 0">
			<div class="media-body">
				<div class="float-right">
					<button
						type="button"
						class="btn btn-success"
						@click="exportarExcel()"
					>
						<i class="far fa-file-excel"></i> Exportar cursos asociados
					</button>
				</div>
				<h5>Cursos {{currentSelector}}</h5>
				<p class="card-title-desc">
				A continuación, verás una tabla que contiene los cursos que tienes a cargo.
				</p>
				<div id="app">
					<!-- <pre>
						{{jsonCurso}}
					</pre> -->
					<v-client-table :data="jsonCurso" :columns="columns" :options="options" >
						<router-link slot="curso" slot-scope="props" :to="'infoCurso/' + props.row.idCurso" >{{ props.row.curso }}</router-link>
						<span slot="fechaInicio" slot-scope="props"> {{ stringToDate(props.row.fechaInicio) }} </span>
					</v-client-table>
				</div>
			</div>
		</div>
	   <PuSkeleton v-else :count="15" />
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import XLSX from "xlsx";
export default {
	data() {
		return {
      loadTablaCurso: false,
      //datosExcel: [], 
      	options: {
        	tituloTabla: ["nombre", "fecha_inicio"],
				headings: {
					idCurso: "#",
					curso: "Nombre Curso",
					campus: "Nombre Campus",
					fechaInicio: "Fecha Inicio",
					cantidadAlumnos: "Cantidad Alumnos",
				},
				sortable: ["idCurso", "curso", "campus", "fechaInicio", "cantidadAlumnos"],
				filterable: ["idCurso", "curso", "campus", "fechaInicio", "cantidadAlumnos"],
				sortIcon:{
					is:'fa-sort',
					base:'fas',
					up: 'fa-sort-up',
					down: 'fa-sort-down'
				},
				texts:{
					noResults: "No hay resultados",
					count:'{count} Registros totales',
					filter:'Buscar: ',
					filterPlaceholder:'Buscar',
					limit:'Registros:',
					noResults:'No hay registros',
					page:'Pagina:', 
					filterBy: 'Filtrar por {column}',
					loading:'Cargando...',
					defaultOption:'Seleccionada {column}'
				}
      		},
	  	
      	columns: ["idCurso", "curso", "campus", "fechaInicio", "cantidadAlumnos"],
    }
	},
	computed:{
		...mapState("curso", ["jsonCurso"]),
		...mapState("curso", ["currentSelector"]),
	},
  	methods:{
    	exportarExcel() {
			var cursoDisponibles = XLSX.utils.json_to_sheet(this.jsonCurso, {
				header: ["idCurso"],
			});
			cursoDisponibles["A1"].v = "idCurso"; 
			var wb = XLSX.utils.book_new(); 
			XLSX.utils.book_append_sheet(wb, cursoDisponibles, "curso disponibles");
			XLSX.writeFile(wb, "cursosDisponibles.xlsx"); // nombre del archivo
    	},
		stringToDate(fecha)
		{
			var datePart = fecha.match(/\d+/g),
			year = datePart[0], // get only two digits
			month = datePart[1], 
			day = datePart[2];
			let formdate = day+'-'+month+'-'+year;
			return formdate;
		}
  	},
};
</script>
<style>
div.form-group.form-inline.float-left.VueTables__search{
	float: right !important;
}
div.form-group.form-inline.float-right.VueTables__limit{
	float: left !important;
}
</style>
